module.exports = __webpack_public_path__ + "static/media/icon-height.433614e8.svg";